import { Component, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { Modalable } from "@app/Modalable"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { TableWrapComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-taskschedules",
	imports: [
		COMMON_IMPORTS,
		TableWrapComponent,
		GenButtonGroupComponent,
		LangValPipe,
		DateFormatPipe,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-table-wrap
			fieldsStr="content,start_date,is_fixed_interval,interval,repetitions,active"
		>
			@for (row of rows; track row.id) {
				<tr>
					<td>{{ row.content }}</td>
					<td>{{ row.start_date | dateFormat }}</td>
					<td>{{ row.is_fixed_interval | langVal }}</td>
					<td>
						@if (row.is_fixed_interval === "yes") {
							{{ row.interval }}
						}
					</td>
					<td>
						@if (row.is_fixed_interval === "yes") {
							{{ row.repetitions }}
						}
					</td>
					<td>
						<app-gen-button-group
							[actualObj]="row"
							fieldName="active"
							optionsListName="yes_no_opts"
							(changeEvent)="update(row)"
						/>
					</td>
				</tr>
			}
		</app-table-wrap>
	`,
})
export class TaskschedulesComponent extends Modalable {
	rows: any = []

	ngOnInit() {
		this.rows = this.store.getSiteDataTable("taskschedules")
	}

	async update(row: any) {
		const res = await this.apiService.save_gen_field(
			"taskschedules",
			row.id,
			"active",
			row.active
		)
		if (res.success) {
			this.store.updGenItemRowField(
				"taskschedules",
				row.id,
				"active",
				row.active
			)
			this.modalService.openToast("update_successfuly")
		}
	}
}
